import React, { useEffect, useRef } from 'react';
import Chart from 'chart.js/auto';
import PropTypes from "prop-types";
import './OverlayCard.scss';

const OverlayCard = ({ data }) => {

    const chartRef = useRef(null);

    useEffect(() => {
        if (chartRef && chartRef.current) {
            const ctx = chartRef.current.getContext('2d');

            const labels = data.map(item => item.name);
            const values = data.map(item => item.value);
            const colors = [
                'rgba(133, 113, 244, 1)',
                'rgba(9, 114, 121, 1)',
                'rgba(48, 206, 216, 1)',
                'rgba(76, 214, 180, 1)',
                'rgba(131, 60, 202, 1)',
                'rgba(30, 156, 164, 1)'
                // Add more colors if needed
            ];

            const total = values.reduce((acc, curr) => acc + curr, 0);
            const percentages = values.map(value => ((value / total) * 100).toFixed(2) + '%');

            const myChart = new Chart(ctx, {
                type: 'pie',
                data: {
                    labels: labels,
                    datasets: [{
                        data: values,
                        backgroundColor: colors,
                        borderColor: colors,
                        borderWidth: 1
                    }]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        tooltip: {
                            callbacks: {
                                label: function (context) {
                                    return context.label + ': ' + context.formattedValue;
                                }
                            }
                        },
                        legend: {
                            display: false
                        }
                    }
                }
            });

            const legend = document.getElementById('legend');

            if (legend) {
                labels.forEach((label, index) => {
                    const li = document.createElement('li');
                    li.textContent = `${label} (${percentages[index]})`; // Display label with percentage
                    li.classList.add('amount-modal');
                    li.style.color = colors[index % colors.length]; // Set text color to white
                    li.style.listStyleType = 'none'; // Remove default bullet style
                    legend.appendChild(li);
            
                    const bullet = document.createElement('span');
                    bullet.textContent = ''; // No text content needed
                    bullet.classList.add('bullet');
                    bullet.style.borderColor = colors[index % colors.length]; // Set border color
                    li.insertBefore(bullet, li.firstChild); // Insert the bullet before the text content
                });
            }

            return () => {
                myChart.destroy();
            };
        }
    }, [data]);

    return (
        <>
            <div className="card" id='overlay'>
                <div className="card-header" id='amount-modal-header'>
                    <p>Payment based on Types</p>
                </div>
                <div className="card-body">
                    {/* <h2>{number}</h2> */}
                    <div>
                        <canvas width="200" ref={chartRef}></canvas>
                    </div>
                    <ul id="legend"></ul>                    
                </div>
                
            </div>
        </>
    );
};

OverlayCard.propTypes = {
    number: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    data: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        value: PropTypes.number.isRequired,
    })).isRequired,
};

export default OverlayCard;
